import React, { useState } from 'react';
import ClockIcon from 'Components/icons/ClockIcon/ClockIcon';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import ChevronUpIcon from 'Components/icons/ChevronUpIcon';
import ChevronDownIcon from 'Components/icons/ChevronDownIcon';
import Button from 'Components/Button/Button';
import { getDisputeStageDetails } from './configStructure.js';
import './TimelineHeader.scss';
import moment from 'moment';
import { COLORS } from "Constants/BIDashboardConstants";

const TimelineHeader = (props) => {
  const {
    eventName,
    eventGeneratedByUser,
    eventTimeStamp,
    eventCode,
  } = props.listItem.eventHeaderDetails;
  const { 
    NoteType,
  } = props.listItem.eventBodyDetails;
  const [isOpen, setOpen] = useState(true);
  const {
    side,
    fill,
    renderIcon,
    listItem
  } = props;
  const openDrawer = (masterId,id, stageId) => {
    props.getApiDrawerData(masterId, id, stageId);
    props.toggleDrawer(true,id);
  };
  const MRErulename = listItem.eventBodyDetails.map((item,index)=>{
    return listItem.eventBodyDetails[index].fields.RuleName && listItem.eventBodyDetails[index].fields.RuleName;
  });
  const isMerchantAutoTakeAction = listItem.eventBodyDetails.map((item,index)=>{
    return listItem.eventBodyDetails[index].fields.AutoAction && listItem.eventBodyDetails[index].fields.AutoAction;
  })
  const horizontal = fill !== 'lightgray' ? '#F0EDF6' : 'lightgray';
  const isVisible = (isOpen && eventCode !== 'CRTE_NEW_ADMIN') ? '' : 'none';
  const displayName = eventName === 'Document removing from case' ? 'Document Removed' : eventName;
  const timelineActionsV2SplitterCards = ['AUTH_MATCHED', 'TRANS_MATCHED','CREDIT_TRANS','REFERENCE_TRANS'];
  const getStageNames = getDisputeStageDetails(eventCode);
  return (
    <div>
      <div className={`vertical-container ${side}`}>
        <div className={`left-icon-container ${side}`}>
          {renderIcon(eventCode, fill)}
        </div>
        <div className="content-container">
          <div className="content-header top">
            <div className="header-left">
              <h3 className={`vertical-timeline-element-title ${side}`}>{timelineActionsV2SplitterCards.includes(eventCode) ? 'Transaction' : displayName}</h3>
              {!timelineActionsV2SplitterCards.includes(eventCode) &&
                <>
                  <hr className="hr" />
                  {MRErulename[0] != undefined && MRErulename[0] != null && props.isMerchantUser && (eventCode === 'MERCHANT_ACCEPT_LIABILITY'||eventCode === 'MERCH_UNABLE_TO_FULFILL' || eventCode === 'MERCHANT_REJECTED_CASE') &&
                  (<h4 className="vertical-timeline-element-subtitle">{"Business Rules / "+eventGeneratedByUser}</h4>)}
                  {isMerchantAutoTakeAction[0] == "true"  && props.isMerchantUser === undefined && (eventCode === 'MERCHANT_ACCEPT_LIABILITY'||eventCode === 'MERCH_UNABLE_TO_FULFILL' || eventCode === 'MERCHANT_REJECTED_CASE') &&
                  (<h4 className="vertical-timeline-element-subtitle">{"MRE / "+eventGeneratedByUser}</h4>)}
                  {MRErulename[0] == undefined && isMerchantAutoTakeAction[0] == undefined  &&
                  (<h4 className="vertical-timeline-element-subtitle">{eventGeneratedByUser}</h4>)}
                  <hr className="hr" />
                </>
              }
              <h4 className="vertical-timeline-element-subtitle aligned">
                <ClockIcon fill="#595959" />
                <span className="time">{(props.isMerchantUser) ? format(eventTimeStamp, `${props.dateFormat} ${props.timeFormat}`): format(eventTimeStamp, 'MMM dd, yyyy hh:mm a')}</span>
              </h4>
            </div>
            {timelineActionsV2SplitterCards.includes(eventCode) && (<span className="timeline-header-button">
              {!props.isMerchantUser && getStageNames !== undefined && getStageNames.buttonList.map((value, index) => {
                return <button onClick={() => { openDrawer(props.listItem.eventBodyDetails[0].fields[value.buttonKey], value.buttonID, props.listItem.caseStageId) }} key={index} className="button-view">{value.buttonName}</button>
              })}
            </span>)}
             { props.children && isOpen && (
              <>
                {eventCode === 'CASE_NOTE' && (
                  <h4 className="vertical-timeline-element-subtitle">{NoteType}</h4>
                )}
                <Button style={timelineActionsV2SplitterCards.includes(eventCode) ? { display: 'none' } : {
                  color: `${COLORS.oneGp.globalBlue}`,
                  marginTop: '1%'
                }} action={() => setOpen(false)} disabled={eventCode === 'CRTE_NEW_ADMIN'}>
                  <ChevronUpIcon width="14" height="8"/>
                </Button>
              </>
              )}
            {
              !isOpen && (
                <>
                  {eventCode === 'CASE_NOTE' && (
                    <h4 className="vertical-timeline-element-subtitle">{NoteType}</h4>
                  )}
                  <Button style={timelineActionsV2SplitterCards.includes(eventCode) ? { display: 'none' } : {
                    color: `${COLORS.oneGp.globalBlue}`,
                    marginTop: '1%'
                  }} action={() => setOpen(true)} disabled={eventCode === 'CRTE_NEW_ADMIN'}>
                    <ChevronDownIcon width="14" height="8" />
                  </Button>
                </>
              )}
          </div>
          <div style={{ display: isVisible }}>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

TimelineHeader.propTypes = {
  children: PropTypes.array,
  side: PropTypes.string,
  fill: PropTypes.string,
  listItem: PropTypes.object.isRequired,
  renderIcon: PropTypes.func.isRequired,
};

TimelineHeader.defaultProps = {
  children: [],
  side: 'left',
  fill: 'grey',
};

export default TimelineHeader;